module.exports = __webpack_public_path__ + "static/forecast/weather/daylightsnow-2ba345a9612d284f6a41a9c527f26779.svg";